
// e.g., in App.jsx
import React from 'react';
import ProgressTile from './ProgressTile';


export default function lossMitigation({data}) {
  if (!data) return null;
  const dataKeys = Object.keys(data);
  return (
    <div 
    style={{width:"85%"}}
    >
      <ProgressTile
        data={data}
        columns={2}    
        keyMap={{
          summary: dataKeys[0],
          entries: dataKeys[1]
        }}
        barHeight={5}
        trackColor="#e6ebf3"
        valueFormatter={(n) =>
          typeof n === 'number' ? n.toLocaleString('en-IN') : n
        }
      />
    </div>
  );
}
